/* BEDZ KING COLLECTION 2.0 — Collection behavior */

(function () {
  'use strict';

  function initCollectionSorting() {
    var selects = document.querySelectorAll(
      '[data-bedz-collection-sort]'
    );

    for (var i = 0; i < selects.length; i++) {
      selects[i].addEventListener('change', function () {
        var url = new URL(window.location.href);

        url.searchParams.set(
          'sort_by',
          this.value
        );

        window.location.href = url.toString();
      });
    }
  }

  function initCollectionNavigation() {
    var selects = document.querySelectorAll(
      '[data-bedz-collection-navigation-select]'
    );

    for (var i = 0; i < selects.length; i++) {
      selects[i].addEventListener('change', function () {
        var selectedOption =
          this.options[this.selectedIndex];

        var destinationUrl = selectedOption
          ? selectedOption.getAttribute('data-url')
          : '';

        if (destinationUrl) {
          window.location.href = destinationUrl;
        }
      });
    }
  }

  function getYouTubeId(url) {
    var match;

    if (!url) {
      return '';
    }

    match = url.match(
      /(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/))([A-Za-z0-9_-]{6,})/
    );

    return match ? match[1] : '';
  }

  function setVideoPreview(trigger) {
    var videoUrl = trigger.getAttribute('href');
    var videoId = getYouTubeId(videoUrl);

    var preview = trigger.querySelector(
      '[data-bedz-collection-youtube-preview]'
    );

    if (!videoId || !preview) {
      return;
    }

    preview.setAttribute(
      'src',
      'https://i.ytimg.com/vi/' +
        videoId +
        '/hqdefault.jpg'
    );
  }

  function initCollectionVideo() {
    var modal = document.getElementById(
      'BedzCollectionYoutubeModal'
    );

    if (!modal) {
      return;
    }

    var dialog = modal.querySelector(
      '.bedz-collection-youtube-modal__dialog'
    );

    var player = modal.querySelector(
      '[data-bedz-collection-youtube-player]'
    );

    var modalTitle = document.getElementById(
      'BedzCollectionYoutubeModalTitle'
    );

    var videoLinks = document.querySelectorAll(
      '[data-bedz-collection-youtube="true"]'
    );

    var closeButtons = modal.querySelectorAll(
      '[data-bedz-collection-youtube-close]'
    );

    var activeTrigger = null;

    for (var i = 0; i < videoLinks.length; i++) {
      setVideoPreview(videoLinks[i]);
    }

    function closeModal() {
      if (modal.hidden) {
        return;
      }

      player.replaceChildren();

      modal.hidden = true;

      modal.classList.remove(
        'bedz-collection-youtube-modal--portrait'
      );

      document.body.classList.remove(
        'bedz-collection-youtube-open'
      );

      if (activeTrigger) {
        activeTrigger.focus();
      }

      activeTrigger = null;
    }

    function openModal(trigger) {
      var videoUrl = trigger.getAttribute('href');
      var videoId = getYouTubeId(videoUrl);

      if (!videoId) {
        return false;
      }

      var layout = trigger.getAttribute(
        'data-bedz-youtube-layout'
      );

      var iframe = document.createElement('iframe');

      activeTrigger = trigger;
      player.replaceChildren();

      iframe.src =
        'https://www.youtube-nocookie.com/embed/' +
        videoId +
        '?autoplay=1&rel=0&playsinline=1';

      iframe.title = modalTitle
        ? modalTitle.textContent.trim()
        : 'YouTube video';

      iframe.setAttribute('allowfullscreen', '');

      iframe.setAttribute(
        'allow',
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
      );

      iframe.setAttribute(
        'referrerpolicy',
        'strict-origin-when-cross-origin'
      );

      player.appendChild(iframe);

      modal.classList.toggle(
        'bedz-collection-youtube-modal--portrait',
        layout === 'portrait'
      );

      modal.hidden = false;

      document.body.classList.add(
        'bedz-collection-youtube-open'
      );

      var closeButton = modal.querySelector(
        '.bedz-collection-youtube-modal__close'
      );

      if (closeButton) {
        closeButton.focus();
      }

      return true;
    }

    for (var j = 0; j < videoLinks.length; j++) {
      videoLinks[j].addEventListener(
        'click',
        function (event) {
          if (getYouTubeId(this.getAttribute('href'))) {
            event.preventDefault();
            openModal(this);
          }
        }
      );
    }

    for (var k = 0; k < closeButtons.length; k++) {
      closeButtons[k].addEventListener(
        'click',
        closeModal
      );
    }

    document.addEventListener(
      'keydown',
      function (event) {
        if (modal.hidden) {
          return;
        }

        if (event.key === 'Escape') {
          event.preventDefault();
          closeModal();
          return;
        }

        if (event.key !== 'Tab' || !dialog) {
          return;
        }

        var focusable = dialog.querySelectorAll(
          'button:not([disabled]), iframe, a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );

        if (!focusable.length) {
          return;
        }

        var firstFocusable = focusable[0];
        var lastFocusable =
          focusable[focusable.length - 1];

        if (
          event.shiftKey &&
          document.activeElement === firstFocusable
        ) {
          event.preventDefault();
          lastFocusable.focus();
        } else if (
          !event.shiftKey &&
          document.activeElement === lastFocusable
        ) {
          event.preventDefault();
          firstFocusable.focus();
        }
      }
    );
  }

  function initCollection() {
    initCollectionSorting();
    initCollectionNavigation();
    initCollectionVideo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initCollection
    );
  } else {
    initCollection();
  }
})();
